import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import { TaskModel } from "../task/taskActions/models";

import { messagingApi } from "./messagingApi";

import * as actions from "./actionTypes";

import { Message, MessageDetails } from "./models";

export type MessageAction =
    ({ type: typeof actions.CREATE_CASE_MESSAGE } & Payload<MessageDetails>) |
    ({ type: typeof actions.REPLY_CASE_MESSAGE } & Payload<MessageDetails>) |
    ({ type: typeof actions.GET_CASE_MESSAGES } & Payload<MessageDetails[]>) |
    ({ type: typeof actions.GET_CASE_CONVERSATION_MESSAGES } & Payload<MessageDetails[]>) |
    ({ type: typeof actions.COMPLETE_ACTIONABLE_TASK_SUCCESS } & Payload<TaskModel>);

export const completeActionableTaskSuccess = (payload: TaskModel): MessageAction => ({
    payload,
    type: actions.COMPLETE_ACTIONABLE_TASK_SUCCESS
});

export const createCaseMessageSuccess = (payload: MessageDetails): MessageAction => ({
    payload,
    type: actions.CREATE_CASE_MESSAGE
});

export const replyCaseMessageSuccess = (payload: MessageDetails): MessageAction => ({
    payload,
    type: actions.REPLY_CASE_MESSAGE
});

export const getCaseMessagesSuccess = (payload: MessageDetails[]): MessageAction => ({
    payload,
    type: actions.GET_CASE_MESSAGES
});

export const getCaseConversationMessagesSuccess = (payload: MessageDetails[]): MessageAction => ({
    payload,
    type: actions.GET_CASE_CONVERSATION_MESSAGES
});

export function createCaseMessage(customerId: string, caseId: string, message: Message) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.CREATE_CASE_MESSAGE, messagingApi.create(message, caseId, customerId));
        dispatch(createCaseMessageSuccess(result));
    };
}

export function replyCaseConversation(customerId: string, caseId: string, message: Message) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.CREATE_CASE_MESSAGE, messagingApi.replyCaseConversation(message, caseId, customerId));
        dispatch(replyCaseMessageSuccess(result.messageDetails));
        if (result.taskDetails) {
            dispatch(completeActionableTaskSuccess(result.taskDetails));
        }
    };
}

export function getAllCaseMessages(caseId: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.GET_CASE_MESSAGES, messagingApi.getAll(caseId));
        dispatch(getCaseMessagesSuccess(result));
    };
}

export function getCaseConversationMessages(caseId: string, subject: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.GET_CASE_CONVERSATION_MESSAGES, messagingApi.getCaseConversation(caseId, subject));
        dispatch(getCaseConversationMessagesSuccess(result));
    };
}
